import React, { useState, Fragment, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton, Avatar, Button, MobileStepper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getValue, setValueWithExpire } from '../../../utils/localStorage';
import { isEmpty, findIndex } from '../../../utils/lodash';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: '0px 0px 8px #00000029',
    marginTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(0.25)
  },
  imageAnnouncements: {
    borderRadius: 0,
    fontSize: 15,
    letterSpacing: 0,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(0),
    justifyContent: 'space-between',
    '& *': {
      fontSize: 15,
      letterSpacing: 0,
      '& a': {
        color: theme.palette.tertiary.main
      }
    }
  },
  paddingBottom8: {
    paddingBottom: theme.spacing(1)
  },
  closeButtonImage: {
    height: theme.spacing(1.875),
    width: theme.spacing(1.875),
    position: 'absolute',
    top: '5px',
    right: '5px',
    backgroundColor: '#FFFDE3'
  },
  styleImage: {
    width: '100%',
    height: '100%'
  },
  imageWrapper: {
    position: 'relative',
    cursor: 'pointer'
  },
  mobileStepper: {
    backgroundColor: theme.palette.secondary.main,
    color: '#43425D',
    justifyContent: 'center'
  }
}));

const ImageBanner = props => {
  const [ windowWidth, setWindowWidth ] = useState();
  const [ windowHeight, setWindowHeight ] = useState();
  const [ imageNumber, setImageNumber ] = useState(0);
  const classes = useStyles();
  const [ imageBanner, updateImageBanner ] = useState(props.imageBanner || []);
  const [ displayImageBannerObject, setdisplayImageBannerObject ] = useState(imageBanner);
  const [ showAnimation, setShowAnimation ] = useState(true);

  useEffect(() => {
    let tempDisplayBanner = displayImageBannerObject;
    tempDisplayBanner = tempDisplayBanner.filter(image => {
      return !getValue(`notice-${image['id']}`);
    });
    setdisplayImageBannerObject(tempDisplayBanner);
    setImageNumber(imageNumber % tempDisplayBanner.length);
  }, []);

  const handleWindowResize = () => {
    setWindowHeight(window.innerHeight);
    setWindowWidth(window.innerWidth);
  };

  const handleNext = (autoplay = false) => {
    if (showAnimation || autoplay) {
      setImageNumber((imageNumber + 1) % displayImageBannerObject.length);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize());
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleWindowResize());
    };
  });

  const handleOnClose = (event, noticeId) => {
    event.stopPropagation();
    setValueWithExpire(`notice-${noticeId}`, true, { expires: 365, path: '/' });
    const noticeIndex = findIndex(displayImageBannerObject, notice => notice.id === noticeId);
    if (noticeIndex > -1) {
      const tempDisplayBanner = displayImageBannerObject.filter(image => {
        return !getValue(`notice-${image['id']}`);
      });
      setdisplayImageBannerObject(tempDisplayBanner);
      setImageNumber(imageNumber % tempDisplayBanner.length);
    }
  };

  if (isEmpty(displayImageBannerObject)) {
    return <Fragment />;
  }

  const handleBack = () => {
    if (imageNumber > 0) {
      setImageNumber(imageNumber - 1);
    }
  };

  const getScreenBasedImage = imageBanner => {
    if (!windowWidth) {
      return '';
    }
    if (windowWidth >= 1280) {
      return imageBanner['image_lg_url'];
    } else if (windowWidth >= 960) {
      return imageBanner['image_md_url'];
    }
    return imageBanner['image_sm_url'];
  };

  return (
    <div>
      <Box className={classes.root}>
        <Box
          className={clsx(classes.imageAnnouncements, displayImageBannerObject.length === 1 && classes.paddingBottom8)}
        >
          {displayImageBannerObject && (
            <Box
              key="temp"
              className={classes.imageWrapper}
              onClick={() => window.open(displayImageBannerObject[imageNumber]['image_href'])}
              onMouseEnter={() => setShowAnimation(false)}
              onMouseLeave={() => setShowAnimation(true)}
              onTouchStart={() => setShowAnimation(false)}
              onTouchEnd={() => setShowAnimation(true)}
            >
              <Avatar
                alt="bannerNotices"
                src={getScreenBasedImage(displayImageBannerObject[imageNumber])}
                className={classes.styleImage}
                variant="square"
              />
              {displayImageBannerObject[imageNumber]['dismissable'] && (
                <IconButton
                  className={classes.closeButtonImage}
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={event => handleOnClose(event, displayImageBannerObject[imageNumber]['id'])}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              )}
            </Box>
          )}
          {displayImageBannerObject.length > 1 && (
            <MobileStepper
              variant="dots"
              steps={displayImageBannerObject.length}
              position="static"
              className={classes.mobileStepper}
              activeStep={imageNumber}
              nextButton={
                <Button
                  size="small"
                  onClick={() => handleNext(true)}
                  disabled={imageNumber === displayImageBannerObject.length - 1}
                  onMouseEnter={() => setShowAnimation(false)}
                  onMouseLeave={() => setShowAnimation(true)}
                  onTouchStart={() => setShowAnimation(false)}
                  onTouchEnd={() => setShowAnimation(true)}
                >
                  <KeyboardArrowRight
                    color={imageNumber === displayImageBannerObject.length - 1 ? 'disabled' : 'primary'}
                  />
                </Button>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={imageNumber === 0}
                  onMouseEnter={() => setShowAnimation(false)}
                  onMouseLeave={() => setShowAnimation(true)}
                  onTouchStart={() => setShowAnimation(false)}
                  onTouchEnd={() => setShowAnimation(true)}
                >
                  <KeyboardArrowLeft color={imageNumber === 0 ? 'disabled' : 'primary'} />
                </Button>
              }
            />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default ImageBanner;
